export const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000
export const INACTIVITY_CHECK_INTERVAL_MS = 1000
export const INACTIVITY_STORAGE_THROTTLE_MS = 5000
export const LAST_ACTIVITY_STORAGE_KEY = 'edusaf-last-activity'
export const SESSION_EXPIRED_QUERY = 'session=expired'
export const SESSION_EXPIRED_MESSAGE =
  'Your session expired after 30 minutes of inactivity. Please sign in again.'

export const hasSessionExpired = (lastActivityAt, now = Date.now()) =>
  Number.isFinite(lastActivityAt) &&
  lastActivityAt > 0 &&
  now - lastActivityAt >= INACTIVITY_TIMEOUT_MS

export const isInactivityExpiryLocation = (search = '') =>
  new URLSearchParams(search).get('session') === 'expired'
